/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Metric_Active_Cargos_HintInputs */

const en_inventory_metric_active_cargos_hint = /** @type {(inputs: Inventory_Metric_Active_Cargos_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active inventory shipments`)
};

const es_inventory_metric_active_cargos_hint = /** @type {(inputs: Inventory_Metric_Active_Cargos_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embarques activos de inventario`)
};

/**
* | output |
* | --- |
* | "Active inventory shipments" |
*
* @param {Inventory_Metric_Active_Cargos_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_metric_active_cargos_hint = /** @type {((inputs?: Inventory_Metric_Active_Cargos_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Metric_Active_Cargos_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_metric_active_cargos_hint(inputs)
	return es_inventory_metric_active_cargos_hint(inputs)
});